// extracted by mini-css-extract-plugin
module.exports = {"manifestTitle":"ManifestTitle_manifestTitle__QByfB"};